
import {
  CREATE_TOKEN,
  CREATE_TOKEN_ERROR,
  CREATED_TOKEN,
  FETCH_TOKENS,
  FETCH_TOKENS_ERROR,
  FETCHED_TOKENS
} from 'actions'

import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const reducer = createApiMiddlewareReducer({
  request: FETCH_TOKENS,
  failure: FETCH_TOKENS_ERROR,
  receive: FETCHED_TOKENS
})

export default (state = {}, { type, payload }) => {
  switch (type) {
    case CREATE_TOKEN:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: true,
          didRequestFail: false
        }
      }
    case CREATE_TOKEN_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: true
        }
      }
    case CREATED_TOKEN:
      return {
        ...state,
        [payload.workspaceSlug]: {
          ...state[payload.workspaceSlug],
          isRequesting: false,
          didRequestFail: false,
          data: [
            ...state[payload.workspaceSlug].data,
            {
              ...payload.response.key,
              secret: payload.response.secret
            }
          ]
        }
      }
    case FETCH_TOKENS:
    case FETCH_TOKENS_ERROR:
    case FETCHED_TOKENS:
      return {
        ...state,
        [payload.workspaceSlug]: reducer(state[payload.workspaceSlug], { type, payload })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/tokens.js